<div [dir]="language === 'ar' ? 'rtl' : 'ltr'">
    <div *ngIf="patientAppointmentBill" class="row">
        <div  class="col-lg-6 col-md-6 col-12" >
            <div class="mini-card">
                <div class="mini-header">
                    <h4>💰 {{ language === 'ar' ? 'الدفع' : 'Paiement' }}</h4>
                   <span class="mini-badge"> {{ language !== 'ar' ? 'TND' : 'د.ت' }}</span>
                </div>
                <div class="card-body" *ngIf="patientAppointmentBill">
                    <ng-container *ngIf="!isPaid">
                        <div class="currency-mini">
                            <div class="curr-item" [class.selected]="currency === 'TND'" (click)="currency = 'TND'">
                                            {{ this.patientAppointmentBill.totalAmountTND | number:'1.2-2' }} TND

                                <small>{{ language === 'ar' ? 'دينار' : 'Dinar' }}</small>
                            </div>
                            <div class="curr-item" [class.selected]="currency === 'EUR'" (click)="currency = 'EUR'">
                                            {{ this.patientAppointmentBill.totalAmountEUR | number:'1.2-2' }} €

                                <small>{{ language === 'ar' ? 'يورو' : 'Euro' }}</small>
                            </div>
                            <div class="curr-item" [class.selected]="currency === 'USD'" (click)="currency = 'USD'">
                                            {{ this.patientAppointmentBill.totalAmountUSD | number:'1.2-2' }} $

                                <small>{{ language === 'ar' ? 'دولار' : 'Dollar' }}</small>
                            </div>
                        </div>
                    </ng-container>

                 <div class="info-mini">
   
    <div class="row-mini">
        <span>{{ language === 'ar' ? 'المبلغ الإجمالي' : 'Montant Total' }}</span>
        <span>
            {{ this.patientAppointmentBill.totalAmountTND | number:'1.2-2' }} 
                    {{ language !== 'ar' 
        ?  'TND' : 'د.ت' }}
          
        </span>
    </div>
    <div class="row-mini total">
        <span>{{ language === 'ar' ? 'المبلغ المطلوب دفعه' : 'Montant à Payer' }}</span>
        <span>
            {{ this.patientAppointmentBill.totalAmountTND | number:'1.2-2' }} 
        
                    {{ language !== 'ar' 
        ?  'TND' : 'د.ت' }}
          
        </span>
    </div>
</div>

<button id="bill-update-action" class="btn-mini" (click)="onCreateTransaction(currency)">
    {{ language === 'ar' ? 'ادفع' : 'Payer' }} {{ this.patientAppointmentBill.totalAmountTND | number:'1.2-2' }} 
    {{ language !== 'ar' 
        ?  'TND' : 'د.ت' }}
</button>

                    <div class="footer-mini">
                        <span class="lock">🔒 {{ language === 'ar' ? 'آمن' : 'Sécurisé' }}</span>
                        <span class="note-mini">{{ language === 'ar' ? '€ $ إرشادي' : '$ € indicatifs' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12 p-4" *ngIf="payMeUrl">
            <iframe id="payment-frame"  
 [src]="payMeUrl" sandbox="allow-scripts allow-forms allow-same-origin allow-top-navigation"></iframe>
        </div>
    </div>
</div>